<template>
  <div
    v-if="props.isOpenList"
    class="settings-item"
  >
    <ul class="settings-item__list">
      <li>
        <Checkbox
          :model-value="isAllCategoriesSelected"
          :label="t('settings_item.categories_list.all')"
          class="settings-item__list-item"
          :class="{'settings-item__list-item--selected': isAllCategoriesSelected}"
          @update:model-value="selectCategories(true)"
        />
      </li>
      <ListItem
        v-for="(listItem, i) in newsFeedStore.filterCategories.list"
        :key="i"
        v-model="newsFeedStore.filterCategories.filterList"
        :use-checkbox="true"
        :item="listItem.id"
        @update:model-value="selectCategories(false)"
      >
        {{ listItem.name }}
      </ListItem>
    </ul>
  </div>
</template>

<script setup>
import {defineProps, computed} from "vue";
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import { t } from "@/controllerLK/GlobusLocalization";
import {debounce} from "@/functions/debouncer";

const props = defineProps({
  isOpenList: {
    type: Boolean,
    default: false,
  }
});

const newsFeedStore = useNewsFeedStore();

// Флаг. Выбраны ли все категории.
const isAllCategoriesSelected = computed(() => newsFeedStore.filterCategories.filterList.length === 0);

// Функция. Выбора категории
const selectCategories = async (isAll = false) => {
  if (isAll) {
    newsFeedStore.filterCategories.filterList = [];
  }
  await updateNewsDebounce();
};

// Функция. Обновление новостей
const updateNews = async () => {
  newsFeedStore.clearNewsFeed();
  await newsFeedStore.getNews();
};
const updateNewsDebounce = debounce(updateNews, 700);
</script>

<style lang="scss" scoped>
.settings-item {
  display: flex;
  flex-direction: column;
  gap: 10px;

  &__list {
    &.scroll {
      max-height: 300px;
      overflow-x: hidden;
    }
  }

  &__list-item {
    border-radius: 8px;
    padding: 6px 14px;
    height: 30px;
    cursor: pointer;
    width: 100%;

    &--selected {
      :deep(.checkbox__label) { color: var(--text-text-on); }
      &:hover { background-color: var(--background-bg-active-hover); }
    }

    &:hover:not(&--selected) {
      background: var(--background-bg-hover);
    }
  }
}
</style>